import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse
} from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { NetsolinApp } from '../../shared/global';
import { OappService } from '../services/oapp.service';
import { GlobalService } from "./global.service";
import { NetsolinService } from "./netsolin.service";
@Injectable()
export class MantbasicaService {
  constructor(private http: HttpClient,public oapp: OappService,
    private globalfb: GlobalService, public service: NetsolinService) {}

  getRegistros(
    ptabla: string,
    paplica: string,
    pcampollave: string,
    pclase_nbs: string,
    pclase_val: string,
    pfiltro?: string
  ): Observable<any> {
    // NetsolinApp.urlNetsolin = localStorage.getItem("urlNetsolin") || '{}';
    NetsolinApp.objenvrestcrud.usuario = this.globalfb.user.id;
    NetsolinApp.objenvrestcrud.psw = NetsolinApp.oapp.cuserpsw;
    NetsolinApp.objenvrestcrud.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    NetsolinApp.objenvrestcrud.tokenfb = this.service.ult_tokenfb;
    NetsolinApp.objenvrestcrud.tabla = ptabla;
    NetsolinApp.objenvrestcrud.orden = "";
    NetsolinApp.objenvrestcrud.aplica = parseInt(paplica);
    NetsolinApp.objenvrestcrud.campos = "*";
    NetsolinApp.objenvrestcrud.campollave = pcampollave;
    NetsolinApp.objenvrestcrud.clase_val = pclase_val;
    NetsolinApp.objenvrestcrud.clase_nbs = pclase_nbs;
    NetsolinApp.objenvrestcrud.llave = "";
    NetsolinApp.objenvrestcrud.cursor = "Tcursorx";
    NetsolinApp.objenvrestcrud.filtro = (typeof pfiltro === 'undefined') ? "*" : pfiltro;
    // "*";
    console.log()
    return this.http
      .post(
        NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc",
        NetsolinApp.objenvrestcrud
      )
      .pipe(
        map(resul => {
          // console.log('map getNetsolinMantbas');
          //  console.log(resul);
          return resul;
        })
      );
  }
  getRegistrosCRMdeta(
    ptabla: string,
    paplica: string,
    pcampollave: string,
    pclase_nbs: string,
    pclase_val: string,
    filtro: string
  ): Observable<any> {
    NetsolinApp.objenvrestcrud.usuario = this.globalfb.user.id;
    NetsolinApp.objenvrestcrud.psw = NetsolinApp.oapp.cuserpsw;
    NetsolinApp.objenvrestcrud.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    NetsolinApp.objenvrestcrud.tokenfb = this.service.ult_tokenfb;
    NetsolinApp.objenvrestcrud.tabla = ptabla;
    NetsolinApp.objenvrestcrud.orden = "FEC_DCOTIZ";
    NetsolinApp.objenvrestcrud.aplica = parseInt(paplica);
    NetsolinApp.objenvrestcrud.campos = "*";
    NetsolinApp.objenvrestcrud.campollave = pcampollave;
    NetsolinApp.objenvrestcrud.clase_val = pclase_val;
    NetsolinApp.objenvrestcrud.clase_nbs = pclase_nbs;
    NetsolinApp.objenvrestcrud.llave = "";
    NetsolinApp.objenvrestcrud.cursor = "Tcursorx";
    NetsolinApp.objenvrestcrud.filtro = filtro;
    console.log('objeto json getReg', NetsolinApp.objenvrestcrud);
    return this.http
      .post(
        NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc",
        NetsolinApp.objenvrestcrud
      )
      .pipe(
        map(resul => {
          // console.log('map getNetsolinMantbas');
          //  console.log(resul);
          return resul;
        })
      );
  }
  gettablaSearch(
    busqueda: string,
    ptabla: string,
    paplica: string,
    pcampollave: string,
    pclase_nbs: string,
    pclase_val: string,
    pcamponombre: string,
    porden: string,
    pobjeto: string,
    pexporta: string,
    pcamposlista: any
  ): Observable<any> {
    // NetsolinApp.urlNetsolin = localStorage.getItem("urlNetsolin") || '{}';
    NetsolinApp.objenvrestcrud.usuario = this.globalfb.user.id;
    NetsolinApp.objenvrestcrud.psw = NetsolinApp.oapp.cuserpsw;
    NetsolinApp.objenvrestcrud.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    NetsolinApp.objenvrestcrud.tokenfb = this.service.ult_tokenfb;
    NetsolinApp.objenvrestcrud.tabla = ptabla;
    NetsolinApp.objenvrestcrud.orden = porden;
    NetsolinApp.objenvrestcrud.aplica = parseInt(paplica);
    NetsolinApp.objenvrestcrud.campos = "*";
    NetsolinApp.objenvrestcrud.campollave = pcampollave;
    NetsolinApp.objenvrestcrud.clase_val = pclase_val;
    NetsolinApp.objenvrestcrud.clase_nbs = pclase_nbs;
    NetsolinApp.objenvrestcrud.llave = "";
    NetsolinApp.objenvrestcrud.objeto = pobjeto;
    NetsolinApp.objenvrestcrud.exporta = pexporta;
    NetsolinApp.objenvrestcrud.cursor = "Tcursorx";
    console.log("gettablaSearch filtro para buscar busqueda:",busqueda, NetsolinApp.objenvrestcrud);
    if (busqueda == "*") {
      //   console.log("filtro para buscar 1 VA *");
      NetsolinApp.objenvrestcrud.filtro = "*";
    } else {
      console.log("filtro para buscar 2");
      //si viene un igual o > o < es porque ya viene filtro armado y no lo arma
      if (
        busqueda.indexOf("=") > 0 ||
        busqueda.indexOf(">") > 0 ||
        busqueda.indexOf("<") > 0 ||
        busqueda.indexOf("like") > 0 ||
        busqueda.indexOf("LIKE") > 0
      ) {
        console.log("filtro para buscar 3 va por que encontro =");
        NetsolinApp.objenvrestcrud.filtro = busqueda;
      } else {
          console.log("filtro para buscar 2");
          console.log(pcampollave);
        var acllave = pcampollave.split(",");
        //   console.log(acllave);
        //solo tener encuenta 2 para armar condicion
        var lenallave = acllave.length;
        if (acllave.length > 1) {
          var condi = "";
          NetsolinApp.objenvrestcrud.filtro =
            acllave[0] +
            " like '%" +
            busqueda +
            "%' or " +
            acllave[1] +
            " like '%" +
            busqueda +
            "%' or " +
            pcamponombre +
            " like '%" +
            busqueda +
            "%'";
        } else {
          //op abrl 6 2019 si campo llave inicia por id_ es numerico en netsolin y no se busca estos son autonumericos
          //buscar con campos lista los que va amostrar
          console.log('pcamposlista',pcamposlista);
          if (pcamposlista.length>0) {
            let lii = 0;
            NetsolinApp.objenvrestcrud.filtro ="";
            pcamposlista.forEach((element:any) => {
              lii +=1;
              if (element.campo.slice(0,3)==='id_') {
                //saltar no busca por id
                } else {
                  if ( lii > 1) {
                    NetsolinApp.objenvrestcrud.filtro +=" or ";
                  }
                   NetsolinApp.objenvrestcrud.filtro += element.campo +" like '%" +busqueda +"%'";
                }
            });
          } else {
            //como antes
            console.log('filtro busqueda: ',NetsolinApp.objenvrestcrud.filtro);
            if (pcampollave.slice(0,3)==='id_') {
            NetsolinApp.objenvrestcrud.filtro = pcamponombre +" like '%" +busqueda +"%'";
            } else {
              NetsolinApp.objenvrestcrud.filtro =pcampollave +" like '%" +busqueda +"%' or " +pcamponombre +" like '%" +busqueda +"%'";
            }
          }
        }
      }
    }
    console.log("filtro para buscar");
    console.log(NetsolinApp.objenvrestcrud.filtro);
    return this.http
      .post(
        NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc",
        NetsolinApp.objenvrestcrud
      )
      .pipe(
        map(resul => {
          // console.log('map post');
          //  console.log(resul);
          return resul;
        })
      );
  }


  gettablanetSearch(
    busqueda: string,
    ptabla: string,
    paplica: string,
    pcampollave: string,
    pclase_nbs: string,
    pclase_val: string,
    pcamponombre: string,
    porden: string,
    pobjeto: string,
    pexporta: string,
    pcamposlista: any
  ): Observable<any> {
    // NetsolinApp.urlNetsolin = localStorage.getItem("urlNetsolin");
    NetsolinApp.objenvrestcrud.usuario = this.globalfb.user.id;
    NetsolinApp.objenvrestcrud.psw = NetsolinApp.oapp.cuserpsw;
    NetsolinApp.objenvrestcrud.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    NetsolinApp.objenvrestcrud.tokenfb = this.service.ult_tokenfb;
    NetsolinApp.objenvrestcrud.tabla = ptabla;
    NetsolinApp.objenvrestcrud.orden = porden;
    NetsolinApp.objenvrestcrud.aplica = parseInt(paplica);
    NetsolinApp.objenvrestcrud.campos = "*";
    NetsolinApp.objenvrestcrud.campollave = pcampollave;
    NetsolinApp.objenvrestcrud.clase_val = pclase_val;
    NetsolinApp.objenvrestcrud.clase_nbs = pclase_nbs;
    NetsolinApp.objenvrestcrud.llave = "";
    NetsolinApp.objenvrestcrud.objeto = pobjeto;
    NetsolinApp.objenvrestcrud.exporta = pexporta;
    NetsolinApp.objenvrestcrud.cursor = "Tcursorx";
    console.log("gettablaSearch filtro para buscar busqueda:",busqueda, NetsolinApp.objenvrestcrud);
    if (busqueda == "*") {
      //   console.log("filtro para buscar 1 VA *");
      NetsolinApp.objenvrestcrud.filtro = "*";
    } else {
      console.log("filtro para buscar 2");
      //si viene un igual o > o < es porque ya viene filtro armado y no lo arma
      if (
        busqueda.indexOf("=") > 0 ||
        busqueda.indexOf(">") > 0 ||
        busqueda.indexOf("<") > 0 ||
        busqueda.indexOf("like") > 0 ||
        busqueda.indexOf("LIKE") > 0
      ) {
        console.log("filtro para buscar 3 va por que encontro =");
        NetsolinApp.objenvrestcrud.filtro = busqueda;
      } else {
          console.log("filtro para buscar 2");
          console.log(pcampollave);
        var acllave = pcampollave.split(",");
        //   console.log(acllave);
        //solo tener encuenta 2 para armar condicion
        var lenallave = acllave.length;
        if (acllave.length > 1) {
          var condi = "";
          NetsolinApp.objenvrestcrud.filtro =
            acllave[0] +
            " like '%" +
            busqueda +
            "%' or " +
            acllave[1] +
            " like '%" +
            busqueda +
            "%' or " +
            pcamponombre +
            " like '%" +
            busqueda +
            "%'";
        } else {
          //op abrl 6 2019 si campo llave inicia por id_ es numerico en netsolin y no se busca estos son autonumericos
          //buscar con campos lista los que va amostrar
          console.log('pcamposlista',pcamposlista);
          if (pcamposlista.length>0) {
            let lii = 0;
            NetsolinApp.objenvrestcrud.filtro ="";
            pcamposlista.forEach((element:any) => {
              lii +=1;
              if (element.campo.slice(0,3)==='id_') {
                //saltar no busca por id
                } else {
                  if ( lii > 1) {
                    NetsolinApp.objenvrestcrud.filtro +=" or ";
                  }
                   NetsolinApp.objenvrestcrud.filtro += element.campo +" like '%" +busqueda +"%'";
                }
            });
          } else {
            //como antes
            console.log('filtro busqueda: ',NetsolinApp.objenvrestcrud.filtro);
            if (pcampollave.slice(0,3)==='id_') {
            NetsolinApp.objenvrestcrud.filtro = pcamponombre +" like '%" +busqueda +"%'";
            } else {
              NetsolinApp.objenvrestcrud.filtro =pcampollave +" like '%" +busqueda +"%' or " +pcamponombre +" like '%" +busqueda +"%'";
            }
          }
        }
      }
    }
    console.log("filtro para buscar");
    console.log(NetsolinApp.objenvrestcrud.filtro);
    return this.http
      .post(
        NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc",
        NetsolinApp.objenvrestcrud
      )
      .pipe(
        map(resul => {
          // console.log('map post');
           console.log(resul);
          return resul;
        })
      );
  }


  getregTabla(
    id: any,
    ptabla: string,
    paplica: string,
    pcampollave: string,
    pclase_nbs: string,
    pclase_val: string,
    pcamponombre: string
  ): Observable<any> {
    // console.log(id);
    // NetsolinApp.urlNetsolin = localStorage.getItem("urlNetsolin") || '{}';
    NetsolinApp.objenvrestcrud.usuario = this.globalfb.user.id;
    NetsolinApp.objenvrestcrud.psw = NetsolinApp.oapp.cuserpsw;
    NetsolinApp.objenvrestcrud.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    NetsolinApp.objenvrestcrud.tokenfb = this.service.ult_tokenfb;
    NetsolinApp.objenvrestcrud.tabla = ptabla;
    NetsolinApp.objenvrestcrud.orden = "";
    NetsolinApp.objenvrestcrud.aplica = parseInt(paplica);
    NetsolinApp.objenvrestcrud.campos = "*";
    NetsolinApp.objenvrestcrud.campollave = pcampollave;
    NetsolinApp.objenvrestcrud.clase_val = pclase_val;
    NetsolinApp.objenvrestcrud.clase_nbs = pclase_nbs;
    // console.log('getregTabla pcampollave:'+pcampollave);
    if (typeof id == "string") {
      var acllave = pcampollave.split(",");
      var aid = id.split("|");
      // console.log(acllave);
      //solo tener encuenta 2 para armar condicion
      var lstrvalcampollave = "";
      if (acllave.length > 1) {
        var condi = "";
        condi =
          acllave[0] +
          "='" +
          aid[0] +
          "' AND " +
          acllave[1] +
          "='" +
          aid[1] +
          "'";
        NetsolinApp.objenvrestcrud.llave = condi;
      } else {
        NetsolinApp.objenvrestcrud.llave = id;
      }
    } else {
      NetsolinApp.objenvrestcrud.llave = id;
    }
    // console.log("NetsolinApp.objenvrestcrud.llave: "+NetsolinApp.objenvrestcrud.llave);
    NetsolinApp.objenvrestcrud.cursor = "Tcursorx";
    NetsolinApp.objenvrestcrud.filtro = "";
    NetsolinApp.objenvrestcrud.datos = id;
    console.log("getregTabla NetsolinApp.objenvrestcrud:",NetsolinApp.objenvrestcrud);
    return this.http
      .post(
        NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc",
        NetsolinApp.objenvrestcrud
      )
      .pipe(
        map((resul:any) => {
          console.log('getregtabla resul',resul);
          // console.log(resul);
          var result0 = resul[0];
          // console.log(result0);
          //si hay error retorna lista de errores sino el registro solicitado
          if (typeof result0 == "undefined") {
            return resul;
          } else {
            return resul[0];
          }
          // return resul;
        })
      );
  }

  //adicionar
  postregTabla(
    regTabla: any,
    ptabla: string,
    paplica: string,
    pcampollave: string,
    pclase_nbs: string,
    pclase_val: string,
    pcamponombre: string
  ): Observable<any> {
    // NetsolinApp.urlNetsolin = localStorage.getItem("urlNetsolin") || '{}';
    NetsolinApp.objenvrestcrud.usuario = this.globalfb.user.id;
    NetsolinApp.objenvrestcrud.psw = NetsolinApp.oapp.cuserpsw;
    NetsolinApp.objenvrestcrud.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    NetsolinApp.objenvrestcrud.tokenfb = this.service.ult_tokenfb;
    NetsolinApp.objenvrestcrud.tabla = ptabla;
    NetsolinApp.objenvrestcrud.orden = "";
    NetsolinApp.objenvrestcrud.aplica = parseInt(paplica);
    NetsolinApp.objenvrestcrud.campos = "*";
    NetsolinApp.objenvrestcrud.campollave = pcampollave;
    NetsolinApp.objenvrestcrud.clase_val = pclase_val;
    NetsolinApp.objenvrestcrud.clase_nbs = pclase_nbs;
    // console.log('postregTabla pcampollave:'+pcampollave);
    var acllave = pcampollave.split(",");
    // console.log(acllave);
    //solo tener encuenta 2 para armar condicion
    var lstrvalcampollave = "";
    if (acllave.length > 1) {
      var condi = "";
      lstrvalcampollave = "regTabla." + acllave[0];
      condi = acllave[0] + "='" + eval(lstrvalcampollave) + "'";
      lstrvalcampollave = "regTabla." + acllave[1];
      condi =
        condi + " AND " + acllave[1] + "='" + eval(lstrvalcampollave) + "'";
      NetsolinApp.objenvrestcrud.llave = condi;
    } else {
      // console.log('postregTabla ELSE pcampollave NO ESPLIT:'+pcampollave);
      // console.log('postregTabla regTabla');
      // console.log(regTabla);
      //op jul 29 22 si llave es compuesta
      var llavesplit = pcampollave.split("+");
      lstrvalcampollave = '';
      if (llavesplit.length > 1) {
        for (let llave of llavesplit) {
          if (lstrvalcampollave.length>0){
            lstrvalcampollave += '+';
          }
          lstrvalcampollave += "regTabla." + llave;
        }
      } else {
        lstrvalcampollave = "regTabla." + pcampollave;
      }
      // console.log('postregTabla strval campollave:'+lstrvalcampollave);
      NetsolinApp.objenvrestcrud.llave = eval(lstrvalcampollave);
      // console.log('postregTabla NetsolinApp.objenvrestcrud.llave:'+NetsolinApp.objenvrestcrud.llave);
    }
    // console.log('postregTabla strval campollave:'+lstrvalcampollave);
    // console.log('postregTabla val campollave:'+NetsolinApp.objenvrestcrud.llave);
    NetsolinApp.objenvrestcrud.cursor = "Tcursorx";
    NetsolinApp.objenvrestcrud.filtro = "";
    NetsolinApp.objenvrestcrud.datos = regTabla;
    // console.log(NetsolinApp.objenvrestcrud);
    return this.http
      .post(
        NetsolinApp.urlNetsolin + "restcrudtablanetsolin.csvc",
        NetsolinApp.objenvrestcrud
      )
      .pipe(
        map(resul => {
          return resul;
        })
      );
  }
  deleteRegTabla(
    regTabla: any,
    ptabla: string,
    paplica: string,
    pcampollave: string,
    pclase_nbs: string,
    pclase_val: string
  ): Observable<any> {
    NetsolinApp.objenvrestcrud.usuario = this.globalfb.user.id;
    NetsolinApp.objenvrestcrud.psw = NetsolinApp.oapp.cuserpsw;
    NetsolinApp.objenvrestcrud.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    NetsolinApp.objenvrestcrud.tokenfb = this.service.ult_tokenfb;
    NetsolinApp.objenvrestcrud.tabla = ptabla;
    NetsolinApp.objenvrestcrud.orden = "";
    NetsolinApp.objenvrestcrud.aplica = parseInt(paplica);
    NetsolinApp.objenvrestcrud.campos = "*";
    NetsolinApp.objenvrestcrud.campollave = pcampollave;
    NetsolinApp.objenvrestcrud.clase_val = pclase_val;
    NetsolinApp.objenvrestcrud.clase_nbs = pclase_nbs;
    // console.log('postregTabla pcampollave:'+pcampollave);
    var acllave = pcampollave.split(",");
    // console.log(acllave);
    //solo tener encuenta 2 para armar condicion
    var lstrvalcampollave = "";
    if (acllave.length > 1) {
      var condi = "";
      lstrvalcampollave = "regTabla." + acllave[0];
      condi = acllave[0] + "='" + eval(lstrvalcampollave) + "'";
      lstrvalcampollave = "regTabla." + acllave[1];
      condi =
        condi + " AND " + acllave[1] + "='" + eval(lstrvalcampollave) + "'";
      NetsolinApp.objenvrestcrud.llave = condi;
    } else {
      lstrvalcampollave = "regTabla." + pcampollave;
      NetsolinApp.objenvrestcrud.llave = eval(lstrvalcampollave);
    }
    NetsolinApp.objenvrestcrud.cursor = "Tcursorx";
    NetsolinApp.objenvrestcrud.filtro = "";
    NetsolinApp.objenvrestcrud.datos = regTabla;
    return this.http
      .request('delete',
        NetsolinApp.urlNetsolin + "restcrudtablanetsolin.csvc",{
        body:NetsolinApp.objenvrestcrud}
      )
      .pipe(
        map(resul => {
          return resul;
        })
      );
  }

  putregTabla(
    regTabla: any,
    id: any,
    ptabla: string,
    paplica: string,
    pcampollave: string,
    pclase_nbs: string,
    pclase_val: string,
    pcamponombre: string
  ): Observable<any> {
    // NetsolinApp.urlNetsolin = localStorage.getItem("urlNetsolin") || '{}';
    NetsolinApp.objenvrestcrud.usuario = this.globalfb.user.id;
    NetsolinApp.objenvrestcrud.psw = NetsolinApp.oapp.cuserpsw;
    NetsolinApp.objenvrestcrud.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    NetsolinApp.objenvrestcrud.tokenfb = this.service.ult_tokenfb;
    NetsolinApp.objenvrestcrud.tabla = ptabla;
    NetsolinApp.objenvrestcrud.orden = "";
    NetsolinApp.objenvrestcrud.aplica = parseInt(paplica);
    NetsolinApp.objenvrestcrud.campos = "*";
    NetsolinApp.objenvrestcrud.campollave = pcampollave;
    NetsolinApp.objenvrestcrud.clase_val = pclase_val;
    NetsolinApp.objenvrestcrud.clase_nbs = pclase_nbs;
    // console.log('putregTabla pcampollave:'+pcampollave);
    var acllave = pcampollave.split(",");
    var aid = id.split("|");
    // console.log(acllave);
    //solo tener encuenta 2 para armar condicion
    var lstrvalcampollave = "";
    if (acllave.length > 1) {
      var condi = "";
      condi =
        acllave[0] +
        "='" +
        aid[0] +
        "' AND " +
        acllave[1] +
        "='" +
        aid[1] +
        "'";
      NetsolinApp.objenvrestcrud.llave = condi;
    } else {
      NetsolinApp.objenvrestcrud.llave = id;
    }
    NetsolinApp.objenvrestcrud.cursor = "Tcursorx";
    NetsolinApp.objenvrestcrud.filtro = "";
    NetsolinApp.objenvrestcrud.datos = regTabla;
    NetsolinApp.objenvrestcrud.delete = "N";
    // return this.http.put(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", NetsolinApp.objenvrestcrud)
    // console.log("modificar a llamar servicio");
    return this.http
      .put(
        NetsolinApp.urlNetsolin + "restcrudtablanetsolin.csvc",
        NetsolinApp.objenvrestcrud
      )
      .pipe(
        map(resul => {
          // console.log("modificar retorna servicio");
          // console.log(resul);
          return resul;
        })
      );
  }
  //trae una lista de una tabla pequeña como solcombog
  public getListadropdown(filtro: any,tabla: string,orden: string,aplica: number,objeto: string,filtroadi: any): any {
		var pobjllama = { ...NetsolinApp.objenvrestsolcomobog};

    pobjllama.usuario = this.globalfb.user.id;
    pobjllama.psw = NetsolinApp.oapp.cuserpsw;
    pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    pobjllama.tokenfb = this.service.ult_tokenfb;
    pobjllama.tabla = tabla;
    pobjllama.orden = orden;
    pobjllama.aplica = aplica;
    pobjllama.filtro = filtro;
    pobjllama.llave = '';
    pobjllama.objeto = objeto;
    pobjllama.filtroadi=filtroadi;
    pobjllama.cursor = "Tcursorx";
    console.log("getListadropdown por netsolin pobjllama");
    console.log(pobjllama);
    return this.http
      .post(
        NetsolinApp.urlNetsolin + "NetsolComobog.csvc",
        pobjllama
      )
      .pipe(
        map(resul => {
          console.log("getListadropdown por netsolin resul");
          console.log(resul);
          return resul;
        })
      );
  }

  deleteTabla(
    regtabla: any,
    id: any,
    ptabla: string,
    paplica: string,
    pcampollave: string,
    pclase_nbs: string,
    pclase_val: string
  ): Observable<any> {
    // NetsolinApp.urlNetsolin = localStorage.getItem("urlNetsolin") || '{}';
    NetsolinApp.objenvrestcrud.usuario = this.globalfb.user.id;
    NetsolinApp.objenvrestcrud.psw = NetsolinApp.oapp.cuserpsw;
    NetsolinApp.objenvrestcrud.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    NetsolinApp.objenvrestcrud.tokenfb = this.service.ult_tokenfb;
    NetsolinApp.objenvrestcrud.tabla = ptabla;
    NetsolinApp.objenvrestcrud.orden = "";
    NetsolinApp.objenvrestcrud.aplica = parseInt(paplica);
    NetsolinApp.objenvrestcrud.campos = "*";
    NetsolinApp.objenvrestcrud.campollave = pcampollave;
    NetsolinApp.objenvrestcrud.clase_val = pclase_val;
    NetsolinApp.objenvrestcrud.clase_nbs = pclase_nbs;
    // NetsolinApp.objenvrestcrud.llave = id;
    // console.log("deleteTabla pcampollave:" + pcampollave);
    // console.log(typeof id);
    if (typeof id != "number") {
      var acllave = pcampollave.split(",");
      var aid = id.split("|");
      // console.log(acllave);
      //solo tener encuenta 2 para armar condicion
      var lstrvalcampollave = "";
      if (acllave.length > 1) {
        var condi = "";
        condi =acllave[0] + "='" + aid[0] + "' AND " +acllave[1] + "='" + aid[1] +"'";
        NetsolinApp.objenvrestcrud.llave = condi;
      } else {
        NetsolinApp.objenvrestcrud.llave = id;
      }
    } else {
      NetsolinApp.objenvrestcrud.llave = id.toString();
    }
    NetsolinApp.objenvrestcrud.cursor = "Tcursorx";
    NetsolinApp.objenvrestcrud.delete = "S";
    NetsolinApp.objenvrestcrud.filtro = "";

    return this.http
      .put(
        NetsolinApp.urlNetsolin + "restcrudtablanetsolin.csvc",
        NetsolinApp.objenvrestcrud
      )
      .pipe(
        map(resul => {
          return resul;
        })
      );
  }

  getregTablaCRM(
    id: any,
    ptabla: string,
    paplica: string,
    pcampollave: string,
    pclase_nbs: string,
    pclase_val: string,
    pcamponombre: string
  ): Observable<any> {
    // console.log("getregTabla");
    // console.log(id);
    // NetsolinApp.urlNetsolin = localStorage.getItem("urlNetsolin");
    NetsolinApp.objenvrestcrud.usuario = this.globalfb.user.id;
    NetsolinApp.objenvrestcrud.psw = NetsolinApp.oapp.cuserpsw;
    NetsolinApp.objenvrestcrud.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    NetsolinApp.objenvrestcrud.tokenfb = this.service.ult_tokenfb;
    NetsolinApp.objenvrestcrud.tabla = ptabla;
    NetsolinApp.objenvrestcrud.orden = "";
    NetsolinApp.objenvrestcrud.aplica = parseInt(paplica);
    NetsolinApp.objenvrestcrud.campos = "*";
    NetsolinApp.objenvrestcrud.campollave = pcampollave;
    NetsolinApp.objenvrestcrud.clase_val = pclase_val;
    NetsolinApp.objenvrestcrud.clase_nbs = pclase_nbs;
    console.log("Objeto Netsolin App->",NetsolinApp);
    // console.log('getregTabla pcampollave:'+pcampollave);
    if (typeof id == "string") {
      var acllave = pcampollave.split(",");
      var aid = id.split("|");
      // console.log(acllave);
      //solo tener encuenta 2 para armar condicion
      var lstrvalcampollave = "";
      if (acllave.length > 1) {
        var condi = "";
        condi =
          acllave[0] +
          "='" +
          aid[0] +
          "' AND " +
          acllave[1] +
          "='" +
          aid[1] +
          "'";
        NetsolinApp.objenvrestcrud.llave = condi;
      } else {
        NetsolinApp.objenvrestcrud.llave = id;
      }
    } else {
      NetsolinApp.objenvrestcrud.llave = id;
    }
    // console.log("NetsolinApp.objenvrestcrud.llave: "+NetsolinApp.objenvrestcrud.llave);
    NetsolinApp.objenvrestcrud.cursor = "Tcursorx";
    NetsolinApp.objenvrestcrud.filtro = "";
    NetsolinApp.objenvrestcrud.datos = id;
    console.log("Dir Servicio->",this.oapp.datosapp.URL_SERVICIOS + "nets_v_exi_ref.csvc",NetsolinApp.objenvrestcrud);
    return this.http
      .post(
        this.oapp.datosapp.URL_SERVICIOS + "nets_v_exi_ref.csvc",
        NetsolinApp.objenvrestcrud

      )
      .pipe(
        map((resul:any) => {
           console.log('getregtabla resul');
           console.log(resul);
          var result0 = resul[0];
          // console.log(result0);
          //si hay error retorna lista de errores sino el registro solicitado
          if (typeof result0 == "undefined") {
            return resul;
          } else {
            return resul[0];
          }
          // return resul;
        })
      );
  }
  getDiccionarioTabla(aliastabla): Observable<any> {
    NetsolinApp.traerTablaDic.usuario = this.globalfb.user.id;
    NetsolinApp.traerTablaDic.psw = NetsolinApp.oapp.cuserpsw;
    NetsolinApp.traerTablaDic.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    NetsolinApp.traerTablaDic.tokenfb = this.service.ult_tokenfb;
    NetsolinApp.traerTablaDic.aliastabla = aliastabla;
    var tipourl = "netsolin_servirestgo.csvc?VRCod_obj=RESTDICTABLA";
    console.log('Traer DIccionario -> ', NetsolinApp.urlNetsolin + tipourl, JSON.stringify(NetsolinApp.traerTablaDic));
    return this.http
      .post(NetsolinApp.urlNetsolin + tipourl, NetsolinApp.traerTablaDic)
      .pipe(
        map((resul) => {
          // console.log('map getNetsolinMantbas');
          //  console.log(resul);
          return resul;
        })
      );
  }

  getDiccionarioTablaCRM(aliastabla): Observable<any> {
    // NetsolinApp.urlNetsolin = "http://40.85.161.231/CERCANOS/"
    NetsolinApp.traerTablaDic.usuario = this.globalfb.user.id;
    NetsolinApp.traerTablaDic.psw = NetsolinApp.oapp.cuserpsw;
    NetsolinApp.traerTablaDic.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    NetsolinApp.traerTablaDic.tokenfb = this.service.ult_tokenfb;
    NetsolinApp.traerTablaDic.aliastabla = aliastabla;
    var tipourl = "netsolin_servirestgo.csvc?VRCod_obj=RESTDICTABLA";
    console.log('Traer DIccionario -> ', NetsolinApp.urlNetsolin + tipourl, JSON.stringify(NetsolinApp.traerTablaDic));
    return this.http
      .post(NetsolinApp.urlNetsolin + tipourl, NetsolinApp.traerTablaDic)
      .pipe(
        map((resul) => {
          // console.log('map getNetsolinMantbas');
          //  console.log(resul);
          return resul;
        })
      );
  }


}
